import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import IRadioInputData from "./IRadioInputData";

interface Props {
    name: string;
    label: string;
    data: IRadioInputData[];
    selectedValue: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioInput = (props: Props) => {

    const renderRadio = (): JSX.Element[] => {
        let result: JSX.Element[] = [];

        props.data.forEach((val, i) => {
            const id = props.name + i;

            result.push(
                <div key={i} className="custom-control custom-radio">
                    <input
                        id={id}
                        name={props.name}
                        className="custom-control-input"
                        type="radio"
                        value={val.value}
                        checked={val.value === props.selectedValue}
                        onChange={props.onChange}
                    />
                    <label
                        className="custom-control-label"
                        htmlFor={id} >
                        {val.label}
                    </label>
                </div>
            )
        })

        return result;
    }

    return <FormGroup inputId={props.name} labelText={props.label}>        
        {renderRadio()}
    </FormGroup>
}

export default RadioInput;